import { decode } from '@finn-no/safe-props';
import { FeedResponse } from '../TransactionFeed/types';

export type AvailableLanguages = 'nb' | 'fi' | 'en' | 'da' | 'se';

export type Dataset = {
    styleLink: string;
    endpoint: string;
    lang: AvailableLanguages;
    urls: {
        internal: {
            statusBuy: string;
            statusSell: string;
        };
    };
    uiData?: FeedResponse;
};

export const getDataProps = () => {
    const tjtElement = document
        .querySelector('tjt-podlet-frontpage-isolated')
        ?.shadowRoot?.querySelector('#tjt-podlet-frontpage') as HTMLElement;
    const encodedProps = tjtElement?.dataset.props;

    if (!encodedProps) {
        throw new Error('tjt-frontpage: Missing data-props');
    }

    const props: Dataset = decode(encodedProps);
    return props;
};
